import React from 'react';
import { motion } from 'framer-motion';
import { CarFront, Key, CreditCardCheck, ArrowsExchange } from './Icons';
interface WhatIOfferProps {
  lang: 'en' | 'es';
}
export const WhatIOffer: React.FC<WhatIOfferProps> = ({
  lang
}) => {
  const content = {
    en: {
      title: 'What I Offer',
      cards: [{
        icon: CarFront,
        title: 'New Vehicles',
        desc: 'Brand new cars from all major manufacturers'
      }, {
        icon: Key,
        title: 'Pre-Owned Cars',
        desc: 'Inspected used vehicles at the best prices'
      }, {
        icon: CreditCardCheck,
        title: 'All Credit Types',
        desc: 'Financing solutions for every budget and credit score'
      }, {
        icon: ArrowsExchange,
        title: 'Trade-Ins Welcome',
        desc: 'Get the best value for your current vehicle'
      }]
    },
    es: {
      title: 'Lo Que Ofrezco',
      cards: [{
        icon: CarFront,
        title: 'Vehículos Nuevos',
        desc: 'Autos nuevos de todas las marcas principales'
      }, {
        icon: Key,
        title: 'Autos Usados',
        desc: 'Vehículos usados inspeccionados al mejor precio'
      }, {
        icon: CreditCardCheck,
        title: 'Todo Tipo de Crédito',
        desc: 'Financiamiento para todo presupuesto y crédito'
      }, {
        icon: ArrowsExchange,
        title: 'Aceptamos tu Auto',
        desc: 'Obtén el mejor valor por tu vehículo actual'
      }]
    }
  };
  const t = content[lang];
  return <section className="py-24 px-6 bg-background" data-id="element-153">
      <div className="max-w-6xl mx-auto" data-id="element-154">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="text-3xl md:text-4xl font-bold text-center mb-16" data-id="element-155">
          {t.title}
        </motion.h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-156">
          {t.cards.map((card, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          delay: index * 0.1
        }} className="bg-card border border-border rounded-xl p-8 flex flex-col items-start hover:border-white/20 transition-colors" data-id="element-157">
              <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center mb-6" data-id="element-158">
                <card.icon className="text-primary" size={24} data-id="element-159" />
              </div>
              <h3 className="text-xl font-semibold mb-3" data-id="element-160">{card.title}</h3>
              <p className="text-[#aaaaaa] leading-relaxed" data-id="element-161">{card.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
};